<template>
  <div class="doctor_info">
    <el-scrollbar :style="{height: ['600px']}" ref="scroll" id="scroll">
      <div class="flex_box">
        <el-form label-position="top" :model="formData" ref="formData" class="formData" :rules="rules">
          <el-form-item label="健康师姓名" prop="doctorName">
            <el-input v-model="formData.doctorName" placeholder="请输入医生姓名" size="small"/>
          </el-form-item>
          <el-form-item label="性别" prop="doctorSex">
            <!-- <el-input v-model="formData.val" placeholder="请输入性别" clearable size="small"/> -->
            <el-radio-group v-model="formData.doctorSex">
              <!-- <el-radio-button label="">全部</el-radio-button> -->
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="身份证号码" prop="doctorIdNo">
            <el-input v-model="formData.doctorIdNo" placeholder="请输入身份证号码" size="small"/>
          </el-form-item>
          <el-form-item label="问诊慢病主类型" prop="labelType">
              <el-select v-model="formData.labelType" placeholder="请选择问诊慢病主类型">
                <el-option label="高血压" :value="1" ></el-option>
                <el-option label="糖尿病" :value="2" ></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="擅长领域" prop="adeptTerritory">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入擅长领域" v-model="formData.adeptTerritory"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="doctorPhoneNum" v-if="formData.doctorId === undefined">
            <el-input v-model="formData.doctorPhoneNum" placeholder="请输入联系电话" size="small" @input="onChangeDocAcc"/>
          </el-form-item>
           <el-form-item label="登录账号" v-if="formData.doctorId === undefined">
            <el-input v-model="formData.doctorAccount" :disabled="true" placeholder="请输入登录账号" size="small"/>
          </el-form-item>
          <el-form-item label="登录密码" prop="doctorPassword" v-if="formData.doctorId === undefined">
            <el-input v-model="formData.doctorPassword" placeholder="请输入登录密码" size="small"/>
          </el-form-item>
          <el-form-item label="健康管理证书/护士证书" prop="practisingCertificate" ref="practisingCertificate">
            <upload @success="getImgUrl(arguments, 'practisingCertificate')" :imageArr="formData.practisingCertificate" :imgLength="1" class="uploader"></upload>
          </el-form-item>
          <el-form-item label="身份证正反面" prop="doctorIdNoImg" ref="doctorIdNoImg">
            <upload @success="getImgUrl(arguments, 'doctorIdNoImg')" :imageArr="formData.doctorIdNoImg" :imgLength="2" class="uploader"></upload>
          </el-form-item>
           <el-form-item label="手写签名" prop="handwrittenSignatureImg" ref="handwrittenSignatureImg">
            <upload @success="getImgUrl(arguments, 'handwrittenSignatureImg')" :imageArr="formData.handwrittenSignatureImg" :imgLength="2" class="uploader"></upload>
          </el-form-item>
        </el-form>
        <div class="up_files">
          <upFiles @getImgUrl="getImgUrl(arguments, 'doctorHeadImg')" :size="'1:1'" :imgUrls="formData.doctorHeadImg" />
        </div>
      </div>
    </el-scrollbar>
    <div slot="footer" class="dialog_footer">
      <el-button :loading="saveLoading" type="primary" @click="save">确 定</el-button>
      <el-button @click="closeDialog">取 消</el-button>
    </div>
  </div>
</template>

<script>
let self = null;
// import { listEnterprise, getEnterprise, delEnterprise, addEnterprise, updateEnterprise, uploadImgBy, changeUserStatus } from "@/api/system/enterprise";
// import { provinceAndCityData, regionData, provinceAndCityDataPlus, regionDataPlus, CodeToText, TextToCode } from 'element-china-area-data';
// import areaPicker from '@/views/components/form/area_picker';
import { addDoctor, editDoctor, getDoctorDetail } from "@/api/system/doctorManage";
import upFiles from './upFiles';
import upload from '@/components/common/uploads';
import { isvalidPhone, validateIdCard } from "@/utils/validate";
export default {
  name: "doctorInfoTpl",
  components: { upFiles, upload },
  props: {
    // formData: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
    show: Boolean,
    doctorId: Number
  },

  watch: {
   // doctorId: {
   //   immediate: true,    // 这句重要
   //   handler (val) {
   //     //console.log(1);
   //     this.resetForm("formData");
   //     this.resetForm("formData2");
   //     if (val) {
   //       this.doctorDetail();
   //     } else {
   //       this.formData = {};
   //     }
   //   }
   // },
   show: {
     immediate: true,    // 这句重要
     handler (val) {
       this.resetForm("formData");
      //  this.resetForm("formData2");
       if (val && this.doctorId) {
         this.doctorDetail();
       } else {
         this.formData = {};
         this.$set(this.formData, 'practisingCertificate', []);
         this.$set(this.formData, 'doctorIdNoImg', []);
         this.$set(this.formData, 'doctorHeadImg', '');
       }
     }
   }
  },
  data() {
    return {
      saveLoading: false,
      formData: {},
      rules: this.getRules()
    };
  },
  created() {
    self = this;
  },
  mounted() {

  },
  methods: {
    onChangeDocAcc() {
      this.formData.doctorAccount = this.formData.doctorPhoneNum;
    },
    onBlurDocAcc() {
      // this.$refs.doctorAccount && this.$refs.doctorAccount.clearValidate();
    },
    doctorDetail() {
      getDoctorDetail(this.doctorId).then((res) => {
        //console.log(res);
        res.data.doctorIdNoImg = res.data.doctorIdNoImg.split(',');
        res.data.practisingCertificate = res.data.practisingCertificate.split(',');
        res.data.handwrittenSignatureImg = res.data.handwrittenSignatureImg.split(',');
        self.formData = res.data || {};
      })
    },
    getImgUrl(url, type) {
      this.formData[type] = url[0];
      // if (url.length > 1) {
      // } else {
      //   this.formData[type] = url;
      // }
      this.$refs[type] && this.$refs[type].clearValidate();
      //console.log(this.formData[type], type, this.formData);
    },
    getParams() {
      let params = JSON.parse(JSON.stringify(this.formData));
      params.doctorHeadImg = this.formData.doctorHeadImg || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
      params.doctorIdNoImg = this.formData.doctorIdNoImg.join(',');
      params.practisingCertificate = this.formData.practisingCertificate.join(',');
      params.handwrittenSignatureImg = this.formData.handwrittenSignatureImg.join(',');
      params.healthManagerType = 2
      return params;
    },
    save() {
      let flag = false;
      // let flag2 = false;
      this.$refs.formData.validate(valid => {flag = valid});
      // this.$refs.formData2.validate(valid => {flag2 = valid});
      if (!flag) return false;
      this.saveLoading = true
      if (self.getParams().doctorId) {
        editDoctor(self.getParams()).then((res) => {
          //console.log(res);
          self.$message.success("修改成功");
          self.closeDialog();
        })
      } else {
        addDoctor(self.getParams()).then((res) => {
          //console.log(res);
          self.$message.success("添加成功");
          self.closeDialog();
        }).finally(_=> {
          this.saveLoading = false
        })
      }
    },
    closeDialog() {
      self.resetForm("formData");
      // self.resetForm("formData2");
      // self.doctorId = 9999999999999999999999999999;
      self.$emit('success', false);
    },
    getRules() {
      return {
        doctorName: [{ required: true, message: '请输入医生姓名', trigger: 'blur' }],
        doctorSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        doctorIdNo: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            required: true,
            validator: (rule, value, callback) => {
                if (!validateIdCard(value)) {
                    // //console.log(self);
                    return callback(new Error('身份证号码格式不正确！'));
                } else {
                    callback();
                }
            },
            trigger: 'blur'
          }
        ],
        doctorHospitalName: [{ required: true, message: '请输入所属机构', trigger: 'blur' }],
        doctorClinic: [{ required: true, message: '请输入所属机构', trigger: 'blur' }],
        labelType: [{ required: true, message: '请选择问诊慢病主类型', trigger: 'change' }],
        adeptTerritory: [{ required: true, message: '请输入擅长领域', trigger: 'blur' }],
        doctorPhoneNum: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            required: true,
            validator: (rule, value, callback) => {
                if (!isvalidPhone(value)) {
                    // //console.log(self);
                    return callback(new Error('联系电话格式不正确,必须用手机号码！'));
                } else {
                    callback();
                }
            },
            trigger: 'blur'
          }
        ],
        doctorAccount: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          {
            required: true,
            validator: (rule, value, callback) => {
                if (!isvalidPhone(value)) {
                    // //console.log(self);
                    return callback(new Error('登录账号格式不正确,必须用手机号码！'));
                } else {
                    callback();
                }
            },
            trigger: 'blur'
          }
        ],
        doctorPassword: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur" }
        ],
        practisingCertificate: [{ required: true, validator: (rule, value, callback) => {
            if (!self.formData.practisingCertificate || self.formData.practisingCertificate.length === 0) {
              return callback(new Error('请上传医生执业证书'))
            } else {
                callback();
            }
        }, trigger: 'blur, change' }],
        doctorIdNoImg: [{ required: true, validator: (rule, value, callback) => {
            if (!self.formData.doctorIdNoImg || self.formData.doctorIdNoImg.length === 0) {
              return callback(new Error('请上传身份证正反面'))
            } else {
                callback();
            }
        }, trigger: 'blur, change' }],
        handwrittenSignatureImg: [{ required: true, validator: (rule, value, callback) => {
            if (!self.formData.handwrittenSignatureImg || self.formData.handwrittenSignatureImg.length === 0) {
              return callback(new Error('请上传手写签名'))
            } else {
                callback();
            }
        }, trigger: 'blur, change' }],
      }
    }
  }
};
</script>
<style lang="less">
  .dialog_footer {
    text-align: right;
  }
  .flex_box {
    display: flex;
    padding-right: 20px;
  }
  .formData {
    margin-right: 20px;
    flex: 1;
  }
  .inline_form {
    display: flex;
    margin-right: 0 !important;
    .el-form-item__label {
      text-align: left;
    }
    .el-form-item__content,.el-form-item__label {
      display: block;
    }
    .el-select {
      width: 100% !important;
    }
    .el-form-item {
      flex: 1;
      margin-right: 0 !important;
    }
    .el-form-item:first-child, .el-form-item:nth-child(2) {
      margin-right: 10px !important;
    }
  }
  .upload {
  .up_files {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
  .uploader {
    flex-wrap: wrap;
    .img {
      width: 33%;
    }
  }
</style>
